/* add_file.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.42 20.09" preserveAspectRatio="none">
        <path class="foreground-gl" d="M15.3,5.5h4L14.92.93V5.12A.38.38,0,0,0,15.3,5.5Z" transform="translate(-0.46 -0.27)"/>
        <path class="foreground-gl" d="M10.82,12.82H7.68V9.94a1.45,1.45,0,1,0-2.89,0v2.88H1.91a1.45,1.45,0,0,0,0,2.9H4.79v3.13a1.45,1.45,0,1,0,2.89,0V15.72h3.14a1.45,1.45,0,0,0,0-2.9Z" transform="translate(-0.46 -0.27)"/>
        <path class="foreground-gl" d="M15.3,7.39A2.27,2.27,0,0,1,13,5.12V.27H6.41a1.5,1.5,0,0,0-1.49,1.5V6.42a3.82,3.82,0,0,1,1.32-.25A3.77,3.77,0,0,1,10,9.94v.56h.82a3.77,3.77,0,0,1,0,7.54H10v.81a3.62,3.62,0,0,1-.32,1.51h8.71a1.49,1.49,0,0,0,1.49-1.49V7.39Z" transform="translate(-0.46 -0.27)"/>
        </svg>
    `
};
